module.exports = __webpack_public_path__ + "img/dksuccess.b2df9c0f.png";